const INFO = {
	main: {
		title: "Reactfolio",
		name: "Trang Nguyen",
		email: "nnhtrang3107@gmail.com",
		logo: "../girl.avif",
	},

	socials: {
		github: "https://github.com/Edgyin42",
		linkedin: "https://www.linkedin.com/in/trangnguyen3107/",
	},

	homepage: {
		title: "Hey, my name is Trang Nguyen. You could call me Hakew :)",
		description:
			"I'm a first-year student pursuing a Bachelor of Computer Science at the University of Adelaide, I'm passionate about doing challenging projects with significant impacts. My goal is to become a software engineer. I love solving problems and creating innovative solutions, and I'm actively gaining foundational knowledge while seeking practical experiences to apply my skills.",
	},

	projects: [
		{
			title: "VisioElements",
			description:
				"Embark on a visually captivating journey through the periodic table with VisioElements – your gateway to a dynamic and interactive exploration of the chemical world. Gone are the days of static tables; VisioElements brings the elements to life, offering an immersive and engaging experience for students, educators, and chemistry enthusiasts alike.",
			logo: "./matlab3.jpeg",
			linkText: "View Project",
			link: "https://github.com/Edgyin42/VisioElements",
		},

		{
			title: "Maze runner",
			description:
				"A game made by C++ using SFML. This was implemented by following the principles of Object-oriented programming.",
			logo: "./Cpp.jpg",
			linkText: "View Project",
			link: "https://github.com/Edgyin42/mazerunner_game",
		},

		{
			title: "Monkey run",
			description:
				"Monkey Run is an interactive game that blends the virtual and real worlds, engaging players through real-world actions. This project was completed while I was competing at Unihack 2024 along with 5 of my friends. The game itself was built using Godot game engine. To detect movements, we used mediapipe, a pose detection library.",
			logo: "./godot.png",
			linkText: "View Project",
			link: "https://github.com/rayokamoto/unihack",
		},
	],
};

export default INFO;
